import { useQuery } from "@tanstack/react-query"
import { loginAxios } from "../config/axios.config";
import { useState } from "react";


const getViewProducts = async (params) => {
  try {
    const { data: {data: response} } = await loginAxios.get(`dashboard/most-viewed`, {
      params,
      headers: {
        'x-auth-token': localStorage.getItem('accessToken')
      }
    });
    return { list: response?.most_viewed_products || [] };
  } catch (error) {
    return Promise.reject(error);
  }
}
const getRtsProductInfo = async (product_id) => {
  try {
    const { data: { data: response } } = await loginAxios.get(`dashboard/rts-product`, {
      params: { product_id },
      headers: {
        'x-auth-token': localStorage.getItem('accessToken')
      }
    });
    return { list: response?.rts_products || [] };
  } catch (error) {
    return Promise.reject(error);
  }
}

export const useGetViewedProducts = () => {
  const [params, setParams] = useState();
  const {data, isLoading, isFetching, refetch } = useQuery(["getViewProducts"], () => getViewProducts());


  return {
    list: data,
    loading: isLoading || isFetching,
    refetch,
    setSearchParams: setParams
  }

}

export const useGetRTSInfo = (productId) => {
  const { data, isLoading, isFetching, refetch } = useQuery(["getRtsProductInfo", productId], () => getRtsProductInfo(productId));


  return {
    rtsInfo: data,
    loading: isLoading || isFetching,
    refetch,
  }
}

// export
